import React, { useMemo } from 'react';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '320px'
};

const MapView = ({ lat = 19.027610778808594, lng = -98.15584564208984, zoom = 17 }) => {
  const center = useMemo(() => ({ lat, lng }), [lat, lng]);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDa-uAJGMQxo_wGlF9o_2u-cojGRAZDr5s'
  });

  if (!isLoaded) return null;

  return (
    <div style={{ borderRadius: 8, overflow: 'hidden', boxShadow: '0 4px 10px rgba(0,0,0,0.25)' }}>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={zoom} options={{ streetViewControl: false, mapTypeControl: false }}>
        <MarkerF position={center} />
      </GoogleMap>
    </div>
  );
};

export default MapView;


